//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UseIronPdfExtensions: FeatureFlag = {"Id":"UseIronPdfExtensions","Label":"Use IronPdf Extensions for signing","Impact":"Allow signing into a non-editable area on the PDF","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
